module.exports = __webpack_public_path__ + "img/title3.7cc18eeb.png";